import { observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';
import { AnalyticsType } from '../types/shared';

export class CheapestListingInfoStore extends Store {
  @observable public price: string;
  @observable public analytics: AnalyticsType;
  @observable public nffAnalytics: AnalyticsType;
  @observable public deviationAnalytics: AnalyticsType;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public clear(): void {
    this.hydrate(CheapestListingInfoStore.DEFAULTS);
  }
}

CheapestListingInfoStore.DEFAULTS = {
  price: null,
  analytics: null,
  nffAnalytics: null,
  deviationAnalytics: null
};
